import React, { ReactElement, useEffect, useState } from "react"
import LineElementRow from "components/Table/LineElementRow"
import LineElementCol from "components/Table/LineElementCol"
import {
  ButtonsContainer,
  ButtonStyled,
  ItalicText,
  LoadingComponentStyled,
  XMLGenResultItem,
  XMLGenResultItemTitle,
  XMLGenResults,
} from "./RequestedTransfers.styled"
import {
  BlockBackground,
  ButtonContainer,
  Container,
  DetailInfo,
  InProgressText,
  LineElementContainerStyled,
  SeeDetailButton,
  TransfersNumber,
  Wrapper,
} from "../WireTransfers.styled"
import { useDispatch, useSelector } from "react-redux"
import { ReduxState } from "types/reduxState.types"
import {
  apiGetAllPayments,
  apiGetNewPayments,
  apiGetRejectedPayments,
  apiMoveNewPaymentsToDone,
  resetPayments,
} from "services/payments"
import { DetailLineHeader } from "../DetailLine/DetailLineHeader"
import { LoadingComponent } from "components/LoadingComponent"
import { WIRE_TRANSFERS_LIMIT } from "../data/constants"
import { DetailLine } from "../DetailLine/DetailLine"
import { PaymentExtended } from "types/payments.types"
import { COLOR } from "utils/color"
import { toast } from "react-toastify"

export const RequestedTransfers = (): ReactElement => {
  const dispatch = useDispatch()
  const paymentsNew = useSelector((state: ReduxState) => state.payments.listNew)

  const [isDetailOpened, setIsDetailOpened] = useState(false)
  const [xmlGenResult, setXmlGenResult] = useState({
    generated: false,
    xmlFileLink: "",
    countTransferred: 0,
    totalAmountTransferred: 0,
    countMissingData: 0,
    countBankAccountUpdateRequired: 0,
  })
  const [isLoadingXmlGen, setIsLoadingXmlGen] = useState(false)
  const [isLoadingDownload, setIsLoadingDownload] = useState(false)
  const [isLoadingUpdatedData, setIsLoadingUpdatedData] = useState(false)

  useEffect(() => {
    dispatch(apiGetNewPayments())
  }, [])

  const paymentsNewData = paymentsNew?.data
  const loadingNewPayments = paymentsNew.loading

  const handleMakeDoneAndExportXML = async () => {
    setIsLoadingXmlGen(true)
    const res = await dispatch(apiMoveNewPaymentsToDone())

    // @ts-ignore
    if (res.payload.request.status !== 200) {
      setIsLoadingXmlGen(false)
      return
    }

    try {
      // @ts-ignore
      const data: {
        xmlFileLink: string
        countTransferred: number
        totalAmountTransferred: number
        countMissingData: number
        countBankAccountUpdateRequired: number
        generated: boolean
        // @ts-ignore
      } = res.payload.data
      data.generated = true

      dispatch(resetPayments())
      setXmlGenResult(data)
      setIsLoadingXmlGen(false)

      setTimeout(() => {
        dispatch(apiGetNewPayments())
        dispatch(apiGetAllPayments({ limit: WIRE_TRANSFERS_LIMIT }))
        dispatch(apiGetRejectedPayments({ limit: WIRE_TRANSFERS_LIMIT }))
      }, 1000)
    } catch (e) {
      setIsLoadingUpdatedData(false)
      console.error(e)
    }
  }

  const downloadXmlFile = async () => {
    try {
      setIsLoadingDownload(true)
      window.open(xmlGenResult.xmlFileLink, "_blank")
    } catch (e) {
      toast.error(e.message)
    } finally {
      setIsLoadingDownload(false)
    }
  }

  return (
    <>
      <Container>
        <Wrapper>
          <LineElementContainerStyled onClick={() => setIsDetailOpened(!isDetailOpened)} lineHeight="lg">
            <LineElementRow>
              <LineElementCol
                width={"10%"}
                size={2}
                content={
                  <div>
                    <InProgressText>Encours</InProgressText>
                  </div>
                }
              />
              <LineElementCol
                size={8}
                width={"30%"}
                content={
                  <TransfersNumber>
                    <ItalicText>{paymentsNewData?.length || 0} virements demandés ⏳</ItalicText>
                  </TransfersNumber>
                }
              />
              <LineElementCol size={5} content={<></>} />
              <LineElementCol
                size={2}
                content={
                  <ButtonContainer>
                    <SeeDetailButton>Voir le détail</SeeDetailButton>
                  </ButtonContainer>
                }
              />
            </LineElementRow>
          </LineElementContainerStyled>
          <BlockBackground isOpened={isDetailOpened} />
        </Wrapper>
        <DetailInfo isOpened={isDetailOpened}>
          <DetailLineHeader />
          {paymentsNewData?.length ? (
            paymentsNewData?.map((payment: PaymentExtended) => (
              <DetailLine key={payment.id} paymentFromBatch={payment} />
            ))
          ) : (
            <></>
          )}
        </DetailInfo>

        {loadingNewPayments || isLoadingDownload || isLoadingXmlGen ? (
          <LoadingComponent />
        ) : (
          <ButtonsContainer>
            {paymentsNewData?.length && !xmlGenResult.generated && !isLoadingXmlGen ? (
              <ButtonStyled disabled={isLoadingXmlGen} onClick={handleMakeDoneAndExportXML}>
                Exporter et marquer comme payé
              </ButtonStyled>
            ) : (
              <></>
            )}
            {xmlGenResult.generated && (
              <>
                <XMLGenResults>
                  <XMLGenResultItem>
                    <XMLGenResultItemTitle>✅ Virements acceptés :</XMLGenResultItemTitle>{" "}
                    {xmlGenResult.countTransferred} pour un total de {xmlGenResult.totalAmountTransferred / 100} €
                  </XMLGenResultItem>
                  <XMLGenResultItem>
                    <XMLGenResultItemTitle>🚩 Virements rejetés (données manquantes) :</XMLGenResultItemTitle>{" "}
                    {xmlGenResult.countMissingData}
                  </XMLGenResultItem>
                  <XMLGenResultItem>
                    <XMLGenResultItemTitle>
                      🚩 Virements rejetés (mise à jour du compte bancaire requise) :
                    </XMLGenResultItemTitle>{" "}
                    {xmlGenResult.countBankAccountUpdateRequired}
                  </XMLGenResultItem>
                </XMLGenResults>
                {xmlGenResult.xmlFileLink && (
                  <ButtonStyled isDownload={COLOR.LIGHT_GREY} onClick={downloadXmlFile}>
                    Télécharger le fichier XML
                  </ButtonStyled>
                )}
              </>
            )}
          </ButtonsContainer>
        )}
      </Container>

      {isLoadingUpdatedData && <LoadingComponentStyled size={"massive"} />}
    </>
  )
}
